import ContainerPainel from 'components/container_painel';
import { StepperHorizontal } from 'components/shared/stepper_horizontal';
import React, { useEffect } from 'react';
import useRegisterTermOfAdhesion from './use_register_term_of_adhesion';
import Step1 from './step1';
import Step2 from './step2';
import { ModuleEnum, PermissionType, usePermissions } from 'contexts/auth/permission_context';
import { ROUTES } from 'routes/constants';
import { useNavigate } from 'react-router-dom';

const RegisterTermOfAdhesion: React.FC = () => {
  const { activeStep, steps, handleNext, handlePrev } =
    useRegisterTermOfAdhesion();
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      (!hasPermission(ModuleEnum.ADHESION_TERM, PermissionType.CREATE))
    ) {
      alert('Você não tem permissão para acessar esta página.');
      navigate(ROUTES.HOME);
    }
  }, []);

  return (
    <ContainerPainel
      pagina='Cadastrar Termos de Adesão Municipal'
      showBackButton={true}
    >
      <StepperHorizontal activeStep={activeStep} steps={steps} />
      {activeStep === 0 && (
        <Step1 onNext={(newAnswers) => handleNext(newAnswers)} />
      )}
      {activeStep === 1 && (
        <Step2
          onNext={(newAnswers) => handleNext(newAnswers)}
          onPrev={handlePrev}
        />
      )}
    </ContainerPainel>
  );
};

export default RegisterTermOfAdhesion;
